












































































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class HobbiesComponent extends Vue {
  public overlayClass = "hobbies-overlay--hidden";
  public overlayImage = "";
  public overlayText = "";

  public openOverlay(src: string, text: string) {
    this.overlayClass = "hobbies-overlay";
    this.overlayImage = src;
    this.overlayText = text;
  }

  public closeOverlay() {
    this.overlayClass = "wow fadeOut animated";
    setTimeout(this.hideAfter, 1500);
  }

  public hideAfter() {
    this.overlayClass = "hobbies-overlay--hidden";
  }
}
